import type { CapabilityWorkflow, ToolCatalog, ToolCatalogTool } from "./types";

/** The `workflow` namespace is reserved for vammo-minions workflows (RFC-0004 §3). */
export const WORKFLOW_GROUP = "workflow";
/** The `memory` namespace is reserved for the user memory actions of vammo-minions (RFC-0006). */
export const MEMORY_GROUP = "memory";

export type CapabilityGroupKind = "workflow" | "memory";

export function groupKind(tool: ToolCatalogTool): CapabilityGroupKind | null {
  if (tool.name === WORKFLOW_GROUP) return "workflow";
  if (tool.name === MEMORY_GROUP) return "memory";
  return null;
}

export const isWorkflowGroup = (tool: ToolCatalogTool) => groupKind(tool) === "workflow";

function minionsGroup(name: string, description: string, items: CapabilityWorkflow[]): ToolCatalogTool {
  return {
    name,
    description,
    actions: items.map((item) => ({ name: item.id, ref: item.ref, description: item.description, kind: item.kind })),
  };
}

/** The tool groups of the catalog, plus the vammo-minions workflow and memory groups. */
export function capabilityGroups(
  catalog: ToolCatalog | undefined,
  descriptions: { workflows: string; memory: string },
): ToolCatalogTool[] {
  if (!catalog) return [];
  const tools = catalog.tools.filter((tool) => groupKind(tool) === null);
  const workflows = catalog.workflows ?? [];
  const memory = catalog.memory ?? [];
  return [
    ...tools,
    ...(workflows.length > 0 ? [minionsGroup(WORKFLOW_GROUP, descriptions.workflows, workflows)] : []),
    ...(memory.length > 0 ? [minionsGroup(MEMORY_GROUP, descriptions.memory, memory)] : []),
  ];
}
